module.exports = __webpack_public_path__ + "img/iso-14001.a832fee.png";